module.exports = __webpack_public_path__ + "img/BA_UpgradeBanner.cf4bd08d.png";